import classes from "./MainPage.module.css";
import AudioPlayer from "../../common/audio-player/AudioPlayer";
import {useEffect} from "react";

function MainPage() {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 1);
        }, 100);
    }, []);
    return (
        <div className={classes.main_page}>
            <div className={classes.container}>
                <AudioPlayer backendUrl="/api"/>
            </div>
        </div>
    )
}

export default MainPage;